import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'

import { DataInput, EmptyInput } from './input-col'
import { InfoData, TaskData } from './info-col'
import { ApproverRow } from './approver-row'

export const ProjectItem = React.memo((props) => {
// console.error(props.project.project_id)
  return (
    <InfoRow>
      <InfoContainer>
        <InfoData
          isEdit={ props.isEdit }
          project={ props.project }
          myProjects={ props.myProjects }
          addTask={ props.addTask }
          deleteProject={ props.deleteProject }
        />
        <EmptyInput
          project={ props.project }
          sumTotalProject={ props.sumTotalProject }
          task={ get(props.project, 'tasks', [])[0] }
          holidays={ props.holidays }
          leaveRequests={ props.leaveRequests }
          compensateRequests={ props.compensateRequests }
          handleClickCell={ props.handleClickCell }
        />
      </InfoContainer>
      <Container>
        <ApproverRow
          project={ props.project }
          myProjects={ props.myProjects }
          isEdit={ props.isEdit }
          handleInputMyTimesheet={ props.handleInputMyTimesheet }
        />
        <EmptyInput
          project={ props.project }
          sumTotalProject={ props.sumTotalProject }
          task={ get(props.project, 'tasks', [])[0] }
          holidays={ props.holidays }
          leaveRequests={ props.leaveRequests }
          compensateRequests={ props.compensateRequests }
          handleClickCell={ props.handleClickCell }
        />
      </Container>
      {props.tasks.map((task, taskID) => {
        return (
          <InputRow
            key={ taskID }
            task={ task }
            taskID={ taskID }
            isEdit={ props.isEdit }
            project={ props.project }
            myProjects={ props.myProjects }
            addTask={ props.addTask }
            deleteProject={ props.deleteProject }
            deleteTask={ props.deleteTask }
            projectID={ props.project.key }
            holidays={ props.holidays }
            leaveRequests={ props.leaveRequests }
            compensateRequests={ props.compensateRequests }
            invalidList={ props.invalidList }
            locations={ props.locations }
            maximumWorkingHoursPerDay={ props.maximumWorkingHoursPerDay }
            authData={ props.authData }
            editHour={ props.editHour }
            handleClickCell={ props.handleClickCell }
            handleInputMyTimesheet={ props.handleInputMyTimesheet }
          />
        )
      })}
    </InfoRow>
  )
})

const InputRow = (props) => {
  return (
    <Container>
      <TaskData
        isEdit={ props.isEdit }
        project={ props.project }
        projectID={ props.projectID }
        task={ props.task }
        taskID={ props.taskID }
        myProjects={ props.myProjects }
        locations={ props.locations }
        addTask={ props.addTask }
        deleteProject={ props.deleteProject }
        deleteTask={ props.deleteTask }
        handleInputMyTimesheet={ props.handleInputMyTimesheet }
      />
      <DataInput
        isEdit={ props.isEdit }
        task={ props.task }
        taskID={ props.taskID }
        project={ props.project }
        projectID={ props.project.key }
        holidays={ props.holidays }
        leaveRequests={ props.leaveRequests }
        compensateRequests={ props.compensateRequests }
        invalidList={ props.invalidList }
        maximumWorkingHoursPerDay={ props.maximumWorkingHoursPerDay }
        authData={ props.authData }
        editHour={ props.editHour }
        handleClickCell={ props.handleClickCell }
      />
    </Container>
  )
}

const Container = styled.div`
  height: 50px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`

const InfoContainer = styled(Container)`
  min-height: fit-content;
  height: fit-content;
`

const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 2px solid #B7B7B7;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/project-item.js